import React from 'react';

import Photo from './photo';
import Comments from './comments';

class Detail extends React.Component {
  render() {
    const { addComment, removeComment } = this.props;

    const { photoId } = this.props.match.params;
    const i = this.props.posts.findIndex((post) => post.id === photoId);
    const post = this.props.posts[i];
    const comments = this.props.comments[photoId] || [];

    return (
      <div>
          <Photo index={i} {...this.props} post={post} />
          <Comments comments={comments} photoId={photoId} addComment={addComment} removeComment={removeComment}/>
      </div>
    )
  }
};

export default Detail;



// WEBPACK FOOTER //
// ./src/components/photogram/detail.js